// extracted by mini-css-extract-plugin
export var copilotHighPriorityLabel = "W1Hm2";
export var copilotInboxHighPriorityIconColor = "c9jhT";
export var copilotInboxLowPriorityIconColor = "HRfwZ";
export var copilotInboxNormalPriorityColor = "EMSgN";
export var copilotInboxPriorityHighContrastColor = "T1Kf6";
export var copilotInboxPriorityIconForMLStyles = "x712j";
export var copilotInboxPriorityIconForRPStyles = "PkYzF";
export var copilotInboxPriorityIconForRPStylesCozyAndCompact = "yOjIy";
export var copilotInboxPriorityIconForSettingsStyles = "kk_QZ";
export var copilotLowPriorityLabel = "W3FQR";
export var iconAndTextContainer = "kgRvs";
export var iconContainer = "pe3au";